import { Button, Card, Typography } from "@material-tailwind/react";
import React from "react";
import { LIST_POSTRUN_REPORT_TABLE_HEAD } from "../../variables/constants";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function PostrunReportTable(props) {
  const handleDownload = () => {
    const data = props.postrunList.map((postrun) => {
      // const startTime = new Date(postrun.start_datetime);
      // const endTime = new Date(postrun.end_datetime);
      // const differenceInMilliseconds = endTime - startTime;

      // const hours = String(
      //   Math.floor(differenceInMilliseconds / (1000 * 60 * 60))
      // ).padStart(2, "0");
      // const minutes = String(
      //   Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60))
      // ).padStart(2, "0");
      // const seconds = String(
      //   Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000)
      // ).padStart(2, "0");

      return [
        "Manifold" + postrun.manifold,
        postrun.start_datetime
          ? moment(postrun.start_datetime).format("DD/MM/YYYY HH:mm")
          : "-",
        postrun.end_datetime
          ? moment(postrun.end_datetime).format("DD/MM/YYYY HH:mm")
          : "-",
        // postrun.start_datetime && postrun.end_datetime
        //   ? hours + ":" + minutes + ":" + seconds
        //   : "-",
        // postrun.postrun_count,
        // "Manifold" + postrun.manifold,
        postrun.postrun_status
          ? postrun.postrun_status == 1
            ? "Completed"
            : postrun.postrun_status == 0
            ? "Running"
            : postrun.postrun_status === 2
            ? "Started"
            : postrun.postrun_status === 3
            ? "Loaded before empty"
            : postrun.postrun_status === 4
            ? "Emptying process successful"
            : postrun.postrun_status === 5
            ? "Detected Low Pressure at M2"
            : postrun.postrun_status === 6
            ? "Detected Low Pressure at M1"
            : "-"
          : "-",
      ];
    });

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      LIST_POSTRUN_REPORT_TABLE_HEAD,
      ...data,
    ]);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Emptying Report");

    // Convert workbook to binary string
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Save the file
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "emptying_report.xlsx"
    );
  };

  return (
    <div>
      {/* <div className="mt-5 md:mt-8"> */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <div>
            <p className="text-2xl font-bold text-black pb-2">
              Emptying Report
            </p>
            <p className="text-black font-semibold text-2xl">
              Branch: {props.postrunList?.[0]?.branch_name}
            </p>
          </div>

          {props.postrunList?.length > 0 && (
            <Button
              onClick={handleDownload}
              className="font-poppins font-medium tracking-wider bg-[#03438D]"
            >
              Download
            </Button>
          )}
        </div>

        {props.postrunList?.length > 0 ? (
          <Card
            className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
            }}
          >
            <table className="w-full min-w-max table-auto text-center">
              <thead>
                <tr>
                  {LIST_POSTRUN_REPORT_TABLE_HEAD.map((head) => (
                    <th
                      key={head}
                      className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-poppins text-white font-semibold uppercase"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.postrunList.map((postrun, index) => {
                  // const startTime = new Date(postrun.start_datetime);
                  // const endTime = new Date(postrun.end_datetime);
                  // const differenceInMilliseconds = endTime - startTime;

                  // const hours = String(
                  //   Math.floor(differenceInMilliseconds / (1000 * 60 * 60))
                  // ).padStart(2, "0");
                  // const minutes = String(
                  //   Math.floor(
                  //     (differenceInMilliseconds % (1000 * 60 * 60)) /
                  //       (1000 * 60)
                  //   )
                  // ).padStart(2, "0");
                  // const seconds = String(
                  //   Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000)
                  // ).padStart(2, "0");

                  return (
                    <tr
                      key={index}
                      className={`${
                        postrun.manifold === 1 ? "bg-[#e6eefe]" : ""
                      }`}
                    >
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          Manifold {postrun.manifold}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.start_datetime
                            ? moment(postrun.start_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.end_datetime
                            ? moment(postrun.end_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.no_of_cylinder || "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.loaded_on
                            ? moment(postrun.end_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                      {/* <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.start_datetime && postrun.end_datetime
                            ? hours + ":" + minutes + ":" + seconds
                            : "-"}
                        </Typography>
                      </td> */}
                      {/* <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun.postrun_count}
                        </Typography>
                      </td> */}
                      {/* <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          Manifold {postrun.manifold}
                        </Typography>
                      </td> */}
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {postrun &&
                          postrun.postrun_status !== undefined &&
                          postrun.postrun_status !== null
                            ? postrun.postrun_status === 1
                              ? "Completed"
                              : postrun.postrun_status === 0
                              ? "Running"
                              : postrun.postrun_status === 2
                              ? "Started"
                              : postrun.postrun_status === 3
                              ? "Loaded before empty"
                              : postrun.postrun_status === 4
                              ? "Emptying process successful"
                              : postrun.postrun_status === 5
                              ? "Detected Low Pressure at M2"
                              : postrun.postrun_status === 6
                              ? "Detected Low Pressure at M1"
                              : "-"
                            : "-"}
                        </Typography>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        ) : (
          <div className="text-center h-[50vh] flex flex-col justify-center items-center">
            <p className="font-semibold text-xl sm:text-3xl">
              Oops! No Data Found...
            </p>
            <p className="text-sm mt-2 ">
              Looks like we couldn't find any data.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PostrunReportTable;
